import axios from '@/utils/request.js'

export const getSystemList = params => {
  // 获取系统列表信息
  return axios.post('/goods/gas/company/getAccessInfo', params)
}

export const addAccessInfo = params => {
  // 添加上次访问数据
  return axios.post('/goods/gas/company/addAccessInfo', params)
}

export const getNoticeList = params => {
  // 通知列表
  return axios.post('/admin/jzl/bGlmNotice/getNoticeList', params)
}
export const read = params => {
  // 已阅
  return axios.post('/admin/jzl/bGlmNoticeReadLog/add', params)
}
